const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'ampvisit',
  'source',
  'afp',
] as const;

type StripUtmPrefix<T> = T extends `utm_${infer R}` ? R : T;
type CleanKeys = StripUtmPrefix<(typeof UTM_KEYS)[number]>;
export type TPayloadUTMParams = {
  [K in CleanKeys]?: string;
};

export function useLoadingQueryParams() {
  function checkModalsOpeners() {
    const params = new URLSearchParams(window.location.search);
    const modal = params.get('modal');

    if (modal === 'signup') {
      stores.modals.showSignUpModal();
    } else if (modal === 'signin') {
      stores.modals.showSignInModal();
    }
  }

  /**
   * Removes UTM parameters from the current URL.
   */
  function removeUTMParamsFromURL() {
    const url = new URL(window.location.href);
    UTM_KEYS.forEach((key) => url.searchParams.delete(key));
    const cleanUrl = url.toString().replace(/([&?])$/, '');
    window.history.replaceState({}, document.title, cleanUrl);
  }

  /**
   * Handles UTM parameters by storing them in local storage and removing them from the URL.
   */
  function handleUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    UTM_KEYS.filter((key) => urlParams.has(key)).forEach((key) => localStorage.setItem(key, urlParams.get(key)));

    removeUTMParamsFromURL();
  }

  /**
   * Retrieves UTM parameters from local storage.
   */
  function getUTMParams(): TPayloadUTMParams {
    return UTM_KEYS.reduce((params, key) => {
      const value = localStorage.getItem(key);
      if (value) params[key.replace('utm_', '')] = value;
      return params;
    }, {});
  }

  /**
   * Removes UTM parameters from local storage.
   */
  function removeUTMParamsFromLocalStorage() {
    UTM_KEYS.forEach((key) => localStorage.removeItem(key));
  }

  function callTrafficTracker() {
    const data = getUTMParams();
    if (typeof data !== 'object' || !Object.keys(data).length) return;
    const { $authApi } = useTypedNuxtApp();
    $authApi.post<{ status: string }>('/traffic_tracker', data).then();
  }

  return {
    checkModalsOpeners,
    handleUTMParams,
    getUTMParams,
    removeUTMParamsFromLocalStorage,
    callTrafficTracker,
  };
}
